<template>
  <div class="full-calendar-header">
    <div class="header-left">
      <slot name="header-left" />
    </div>
    <div class="header-center">
      <span class="prev-month" @click.stop="$_onPrevClick">{{ leftArrow }}</span>
      <span class="title">{{ title }}</span>
      <span class="next-month" @click.stop="$_onNextClick">{{ rightArrow }}</span>
    </div>
    <div class="header-right">
      <slot name="header-right" />
    </div>
  </div>
</template>
<script>
import dateFunc from './dateFunc'

export default {
  props: {
    currentDate: {
      type: Date
    },
    titleFormat: {
      type: String
    },
    firstDay: {
      type: Number | String
    },
    monthNames: {
      type: Array,
      default() {
        return []
      }
    },
    shortMonthNames: {
      type: Array,
      default() {
        return []
      }
    },
  },
  data() {
    return {
      title: '',
      leftArrow: '<',
      rightArrow: '>',
      headDate: new Date()
    }
  },
  watch: {
    currentDate(val) {
      if (!val) return
      this.headDate = val
      // this.headDate = JSON.parse(JSON.stringify(val))
    }
  },
  created() {
    this.$_dispatchEvent()
  },
  methods: {
    $_onPrevClick() {
      this.headDate = this.$_changeMonth(this.headDate, -1)
      this.$_dispatchEvent()
    },
    $_onNextClick() {
      this.headDate = this.$_changeMonth(this.headDate, 1)
      this.$_dispatchEvent()
    },
    $_changeMonth(date, num) {
      let dt = new Date(date)
      return new Date(dt.setMonth(dt.getMonth() + num))
    },
    $_dispatchEvent() {
      this.title = dateFunc.format(
        this.headDate,
        this.titleFormat,
        this.monthNames,
        this.shortMonthNames,
      )

      let startDate = dateFunc.getStartDate(this.headDate)
      let curWeekDay = startDate.getDay()

      // 1st day of this monthView
      let diff = parseInt(this.firstDay) - curWeekDay
      if (diff) diff -= 7
      startDate.setDate(startDate.getDate() + diff)

      // the month view is 6*7
      let endDate = dateFunc.changeDay(startDate, 41)

      // 1st day of current month
      let currentDate = dateFunc.getStartDate(this.headDate)

      this.$emit(
        'change',
        dateFunc.format(startDate, 'yyyy-MM-dd'),
        dateFunc.format(endDate, 'yyyy-MM-dd'),
        dateFunc.format(currentDate, 'yyyy-MM-dd'),
        this.headDate
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// header.vue?22f1ecc6